import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BusinessData, GoogleRatings, ManageBusinessData, UpdateBusinessData } from '@app/api/models/api-models';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ClaimingDialogActions, ClaimingStage } from '@app/api/models/claiming.models';
import { setLocalStorageClaimingFlag } from '@app/core/utils/claiming.utils';

import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ICustomerFeedback } from '@app/api/models/uberal.models';

@Component({
  selector: 'rating',
  templateUrl: 'rating.component.html',
  styleUrls: ['./rating.component.scss'],
  providers: [NgbRatingConfig],
  standalone: false,
})
export class RatingComponent {
  @Input() ratings: GoogleRatings;
  @Input() nReviews: number;
  @Input() claimingStage: ClaimingStage;
  @Input() language: string;
  @Input() businessData: BusinessData;
  @Input() loading: boolean;
  @Input() isMacUser: boolean;
  @Input() increaseContainersHeight: boolean;
  @Input() dataCheckFailed: boolean;

  @Output() retryEmitter = new EventEmitter<void>();
  @Output() getAllEvent = new EventEmitter<any>();
  @Output() reactivateBusinessEvent = new EventEmitter<any>();
  @Output() claimingDialogActionEmitter = new EventEmitter<ClaimingDialogActions>();

  ratingOpts = ['five', 'four', 'three', 'two', 'one'];
  claimingStages = ClaimingStage;

  constructor(
    private config: NgbRatingConfig,
    private router: Router,
    public dialog: MatDialog,
    public bottomsheet: MatBottomSheet
  ) {
    this.config.max = 5;
    this.config.readonly = true;
  }

  goToReviews() {
    this.router.navigate(['/main/review']);
  }

  calculatePercentage(rating) {
    const { average } = this.ratings;
    return (rating / average) * 100;
  }

  getAverageFormat(average) {
    const rounded = parseFloat(average.toFixed(1));
    if (average % 1 === 0) {
      return `${rounded}.0`;
    }
    return rounded;
  }

  openClaimListingDialog() {
    setLocalStorageClaimingFlag();
    this.claimingDialogActionEmitter.emit(ClaimingDialogActions.OPEN_CLAIMING_DIALOG);
  }

  openStage3Bottomsheet(): void {
    this.claimingDialogActionEmitter.emit(ClaimingDialogActions.CHECK_STATE);
  }

  reactivate() {
    const payload: UpdateBusinessData = {
      id: this.businessData.id,
      businessUnit: { data: this.businessData, channels: ['GOOGLE_MY_BUSINESS'] } as ManageBusinessData,
    };
    this.reactivateBusinessEvent.emit(payload);
  }

  goToProfileTab() {
    this.router.navigate(['/main/profile']);
  }

  retry(): void {
    this.retryEmitter.emit();
  }
}
